import GenericTopPostsDrawer from './GenericTopPostsDrawer';
import { getBrandCat1TopPosts } from 'utils/api/instagram.api';

const BrandTopPostsDrawer = ({
    year,
    week,
    brands,
    categories,
    countries,
    name,
    displayQty,
}) => {
    const queryParams = {
        brand: brands || null,
        category: categories || null,
        country: countries || null,
        page: 1,
        per_page: 500,
    };

    return (
        <GenericTopPostsDrawer
            year={year}
            week={week}
            name={name}
            displayQty={displayQty}
            queryFn={getBrandCat1TopPosts}
            queryParams={queryParams}
        />
    );
};

export default BrandTopPostsDrawer;
